<template>
  <b-card v-if="!!option" id="page-school-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }} {{ $t("pages.schools.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group :label="$t(label('name'))" label-for="nombre">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="nombre"
                    v-model="school.nombre"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--  Stores -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('stores'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('stores'))"
                  label-for="idCatTienda"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="idCatTienda"
                    v-model="school.idCatTienda"
                    :options="listCatalogStores"
                    label="name"
                    :placeholder="$t(label('stores'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!--  sportUniform -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('sportUniform'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('sportUniform'))"
                  label-for="idCatDeportivo"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="idCatDeportivo"
                    v-model="school.idCatDeportivo"
                    :options="listCatalogSports"
                    label="name"
                    :placeholder="$t(label('sportUniform'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!--  dailyUniform -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('dailyUniform'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('dailyUniform'))"
                  label-for="idCatDiario"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="idCatDiario"
                    v-model="school.idCatDiario"
                    :options="listCatalogDaily"
                    label="name"
                    :placeholder="$t(label('dailyUniform'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('phone'))" label-for="phone">
                <vue-tel-input
                  inputId="phoneNumber"
                  name="phoneNumber"
                  v-model="school.telefono"
                  :mode="'international'"
                  defaultCountry="ve"
                  :disabledFetchingCountry="true"
                  :inputOptions="inputTelOption"
                  @open="onDropdownOpen(true)"
                  @close="onDropdownOpen(false)"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ openTelInput ? "▲" : "▼" }}</span>
                  </template>
                </vue-tel-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t(label('address'))" label-for="direccion">
                <b-form-textarea
                  id="direccion"
                  v-model="school.direccion"
                  :placeholder="$t(label('address'))"
                  :disabled="!isSaveMode"
                  rows="6"
                />
              </b-form-group>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
  BAlert,
  BFormInvalidFeedback,
  BFormGroup,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";
import vSelect from "vue-select";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import {
  createOrEditFamcosColegio,
  getFamcosColegio,
} from "@core/api/request/schoolsFamcos";
import { getCatalog } from "@core/api/request/catalogs";

const school = {
  idColegio: null,
  nombre: "",
  guidCompany: null,
  idCatDiario: null,
  idCatDeportivo: null,
  direccion: "",
  telefono: "",
  idCatTienda: null,
};

export default {
  components: {
    BAlert,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    vSelect,
    VueTelInput,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    loading: false,
    isSaveMode: true,
    required,
    option: "",
    school: Object.assign(school),
    listCatalogSports: [],
    listCatalogDaily: [],
    listCatalogStores: [],
    openTelInput: false,
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
    },
  }),
  computed: {},

  created() {
    localize("es");
    this.initialize();
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.school.guidCompany = guid;
    },
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.schools.form.label.${field}`;
    },

    labelHeader(field) {
      return `pages.schools.table.tableHeader.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "schools" }).catch(() => {});
      }

      switch (this.option) {
        case 1:
          this.onCancel();
          this.loadData(),
            (this.school.guidCompany =
              this.$store.state.appConfig.activeCompanyGuid);
          break;
        case 2:
        case 3:
          if (this.$route.params.idColegio === undefined) {
            router.push({ name: "schools" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          await Promise.all([
            this.loadData(),
            this.showSchool(this.$route.params.idColegio),
          ]);
          break;
      }
    },

    onSubmit() {
      try {
        this.$refs.simpleRules.validate().then((success) => {
          if (success) {
            showLoading();

            const body = {
              idColegio: this.school.idColegio,
              nombre: this.school.nombre,
              idCatDiario: this.school.idCatDiario,
              idCatDeportivo: this.school.idCatDeportivo,
              direccion: this.school.direccion,
              telefono: this.school.telefono,
              idCatTienda: this.school.idCatTienda,
            };

            const id = this.option === 1 ? null : this.school.idColegio;

            createOrEditFamcosColegio(body, id)
              .then(() => {
                this.alertToast(
                  "success",
                  this.$t("Alert"),
                  `${
                    this.option != 3
                      ? this.$t("registerSuccess")
                      : this.$t("updateRecord")
                  }`,
                  "CheckIcon",
                );
                this.goBack();
                stopLoading();
              })
              .catch((error) => {
                console.error("Error loading data", error.message);
                stopLoading();
                this.alertToast(
                  "danger",
                  this.$t("Alert"),
                  error.message,
                  "AlertTriangleIcon",
                );
              });
          }
        });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    async loadData() {
      try {
        showLoading();
        // FAMCOS_UNIFORME_DEPORTIVO
        const arrParamSports = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          `guidCatalog,6adc3080-c9dd-4835-beef-3e336ba3f888`,
        ]);
        // FAMCOS_UNIFORME_DIARIO
        const arrParamDaily = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          `guidCatalog,4ffb0a51-fec2-4e85-a3e4-30c7147fc26c`,
        ]);
        // FAMCOS_TIENDAS
        const arrParamStores = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          `guidCatalog,38cc96b4-bcbd-4948-a19b-39d764677c15`,
        ]);
        const [sportsResp, dailyResp, storesResp] = await Promise.all([
          getCatalog(arrParamSports),
          getCatalog(arrParamDaily),
          getCatalog(arrParamStores),
        ]);

        // Procesamos la respuesta de los servicios
        const sportsData = _.get(sportsResp, "data") || [];
        this.listCatalogSports = sportsData.listOfItems?.items;

        const dailyData = _.get(dailyResp, "data") || [];
        this.listCatalogDaily = dailyData.listOfItems?.items;

        const storesData = _.get(storesResp, "data") || [];
        this.listCatalogStores = storesData.listOfItems?.items;
      } catch (error) {
        console.error("Error loading data", error);
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        stopLoading();
      }
    },

    showSchool(id) {
      showLoading();
      getFamcosColegio(id)
        .then((resp) => {
          stopLoading();
          const school = _.get(resp, "data");

          this.school = Object.assign(this.school, {
            idColegio: school.idColegio,
            nombre: school.nombre || "",
            idCatDiario: school.idCatDiario || null,
            idCatDeportivo: school.idCatDeportivo || null,
            direccion: school.direccion || "",
            telefono: school.telefono || "",
            idCatTienda: school.idCatTienda || null,
          });
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast(
            "danger",
            this.$t("Alert"),
            error.message,
            "AlertTriangleIcon",
          );
        });
    },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      Object.assign(this.school, {
        nombre: "",
        idCatDiario: null,
        idCatDeportivo: null,
        direccion: "",
        telefono: "",
        idCatTienda: null,
      });

      this.listCatalogSports = [];
      this.listCatalogDaily = [];
      this.listCatalogStores = [];
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "../../../../../public/loader.css";
@import "~@core/scss/vue/libs/vue-wizard.scss";
</style>
